import React, { useState, useEffect } from "react"

import { Row, Col } from "react-bootstrap"
import { observer } from "mobx-react"

import { BottomsheetDropdown } from "components"

const GSS = ({ form, data }) => {
  return (
    <div className="save-my-children">
      <div className="mx-0 my-4">
        {/* <Col md={6} className="col-12 mb-3"> */}
        {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light">{form.$("PT").label}</div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey="label"
          bottomsheetTitle={form.$("PT").label}
          menuList={form.$("PT").extra.optionList}
          value={form.$("PT").value}
          onSelect={form.$("PT").onChange}
          disabled={form.$("PT").disabled}
        />
        {/* </Col> */}
      </div>
      <div className="mx-0 my-4">
        {/* <Col md={6} className="col-12 mb-3"> */}
        {/* <div className="mb-2 text-description-text-color font-size-12 font-weight-light">{form.$("PPT").label}</div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey="label"
          bottomsheetTitle={form.$("PPT").label}
          menuList={form.$("PPT").extra.optionList}
          value={form.$("PPT").value}
          onSelect={form.$("PPT").onChange}
          disabled={form.$("PPT").disabled}
        />
        {/* </Col> */}
      </div>
    </div>
  )
}

export default observer(GSS)
